import { useCreateTransactionRuleContext } from './CreateTransactionRuleContext';
import {
  CreateResponseVisualizationStep,
  CreateTransactionModifiersStep,
  CreateTransactionSelectorsStep,
  SelectTransactionStep,
  TransactionGeneralSettingsStep,
} from './steps';
import { CreateTransactionRuleStep } from './types';

const stepToComponent = {
  [CreateTransactionRuleStep.SelectTransaction]: SelectTransactionStep,
  [CreateTransactionRuleStep.CreateTransactionSelectors]:
    CreateTransactionSelectorsStep,
  [CreateTransactionRuleStep.GeneralSettings]: TransactionGeneralSettingsStep,
  [CreateTransactionRuleStep.CreateTransactionModifiers]:
    CreateTransactionModifiersStep,
  [CreateTransactionRuleStep.CreateResponseVisualization]:
    CreateResponseVisualizationStep,
};

export const CreateTransactionRuleSteps = () => {
  const { step } = useCreateTransactionRuleContext();
  const StepComponent = stepToComponent[step];

  return StepComponent ? <StepComponent /> : null;
};
